import {
  FETCH_FAMILYS_REQUEST,
  FETCH_FAMILYS_SUCCESS,
  FETCH_FAMILYS_FAILURE,
  ADD_FAMILYS_REQUEST,
  ADD_FAMILYS_SUCCESS,
  ADD_FAMILYS_FAILURE
} from "./familyActions";

const initialState = {
  loading: false,
  familys: [],
  error: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FAMILYS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_FAMILYS_SUCCESS:
      return {
        loading: false,
        familys: action.payload,
        error: ""
      };
    case FETCH_FAMILYS_FAILURE:
      return {
        loading: false,
        familys: [],
        error: action.payload
      };

    case ADD_FAMILYS_REQUEST:
      return {
        registering: true
      };
    case ADD_FAMILYS_SUCCESS:
      return {
        loading: false,
        familys: [...(state.family || []) , action.payload ],
        error: ""
      };
    case ADD_FAMILYS_FAILURE:
      return {
        loading: false,
        familys: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
